import { useEffect, useState } from "react";
import { useCommunitySwitcherContext } from "@circleco/community-switcher/context/CommunitySwitcherContext";
import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { CreateCommunityModal } from "./CreateCommunityModal";

export const CommunitySwitcherNewCommunityButton = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { featureFlags, t } = useCommunitySwitcherContext();

  useEffect(() => {
    const handlePageShow = (e: PageTransitionEvent) => {
      if (e.persisted) setIsLoading(false);
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, []);
  if (!featureFlags?.showNewCommunityButton || !featureFlags.newCommunityHref) {
    return null;
  }
  if (featureFlags.isElectron) {
    return null;
  }

  const onCreateCommunity = featureFlags.onCreateCommunity;

  return (
    <>
      <Tooltip
        content={t("create_new_community")}
        delay={200}
        side="right"
        sideOffset={12}
      >
        {onCreateCommunity ? (
          <IconButton
            aria-label={t("create_new_community")}
            icon="plus"
            size="sm"
            variant="ghost"
            onClick={() => {
              featureFlags.onCreateCommunityButtonClick?.();
              setIsModalOpen(true);
            }}
          />
        ) : (
          <IconButton
            aria-label={t("create_new_community")}
            icon="plus"
            size="sm"
            variant="ghost"
            loading={isLoading}
            onClick={() => setIsLoading(true)}
            renderLink={<a href={featureFlags.newCommunityHref} />}
          />
        )}
      </Tooltip>
      {onCreateCommunity && (
        <CreateCommunityModal
          open={isModalOpen}
          onOpenChange={setIsModalOpen}
          onSubmit={onCreateCommunity}
          defaultName={featureFlags.newCommunityDefaultName}
        />
      )}
    </>
  );
};
